module.exports = __webpack_public_path__ + "img/b7-3.ae3930c.png";